import { Level2Wrapper } from '../common/Level2Wrapper';
import { ImageList } from '../common/ImageList';
import { AdditionalData, GenericSubSection } from '../common/GenericSubSection';
import { useLevel1SectionData } from '../../hooks/useLevel1Section';
import { useExteriorSectionData } from '../../hooks/useExteriorSection';
import { Section } from 'services/api/vehicle-sections/types';
import { useOBDImages } from '../../hooks/useOBDImages';
import { useGetVehicleId } from 'pages/CreateVehicle/hooks/useGetVehicleId';
import { useGetSectionsQuery } from 'services/api/vehicle-sections';
import { useLicensePlateExpiration } from '../../hooks/useLicensePlateExpiration';

export const ODBCheck = () => {
  const { subSections: interiorSubSections } = useLevel1SectionData('interior_questions');
  const { subSections: tiresSubSections } = useExteriorSectionData('tires');

  const images = useOBDImages();

  const displaySection: Section = {
    id: -1,
    name: 'title_and_registration',
    label: 'Title & Registration',
    notes: null,
    grade: null,
    images: [],
    checkboxes: [],
    audio_url: null,
    subsections: {},
    buyer_order: -1,
    order: -1
  };

  const licensePlateExpiration = useLicensePlateExpiration();

  const nestedSections = [
    interiorSubSections.title_issues,
    tiresSubSections.vin_plate,
    tiresSubSections.license_plate_registration
  ].filter(section => !!section && (!!section.grade || section.name === 'title_issues'));

  const additionalNestedSectionsData: AdditionalData[] = nestedSections.map(s => {
    if (s.name !== 'license_plate_registration') return {};
    return { expirationDate: licensePlateExpiration };
  });

  const sectionCollapsed = nestedSections.every(s => s.grade === 'good');

  return (
    <Level2Wrapper flex="1 1 100%" label="OBD Check/Smog Readiness">
      <ImageList label="OBD Check/Smog Readiness Pictures" images={images} />
      <GenericSubSection
        collapsed={sectionCollapsed}
        section={displaySection}
        additionalData={{ nestedSections, nestedAdditionalData: additionalNestedSectionsData }}
      />
    </Level2Wrapper>
  );
};
